import React from 'react';
import { Chip } from '@mui/material';

type Props = {
  startText: string;
  memberSince: string | Date; // e.g. "2024-11-03" or Date object
};

const SincePill: React.FC<Props> = ({ startText, memberSince }) => {
  const formattedDate = new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(new Date(memberSince)); // Outputs like "Jun 2025"

  return (
    <Chip
      label={`${startText} ${formattedDate}`}
      color='primary'
      variant='outlined'
      sx={{
        borderRadius: '16px',
        fontWeight: 500,
        fontSize: '0.75rem',
        px: 1.5,
        height: 28,
      }}
    />
  );
};

export default SincePill;
